// ----------------------------------------------------------------------
export var Container = function Container() {
  return {
    MuiContainer: {
      styleOverrides: {
        root: {}
      }
    }
  };
};